const ADMIN = "9d11593c-a0d1-4140-be38-cc30b04ef3f7";
const BETA_FEATURE = "51759aa9-f3e7-452b-b6e1-8357715411f9";
const BILLING_ADMIN = "d793dffc-103e-431c-8c3c-d5fa160c1c33";
const CALAMITY_ADMIN = "fa3206da-9b8f-466b-8bc1-4584c8c6e07d";
const CALLS_ADMIN = "0f4f0654-891b-450f-bc65-88b44aa53cdb";
const CLIENT_ADMIN = "20786715-004d-47bd-875e-4dd311f939ac";
const COURIER_ADMIN = "20830abf-9052-4fa0-9330-072635a8966c";
const FLIGHTS_ADMIN = "09f79182-3afe-469b-9526-b7d808a61ecd";
const HIDDEN = "HIDDEN_TAB";
const PHONES_ADMIN = "317d3dc4-8ac6-40f3-8819-5a18ef5dfe5e";
const QUEUE_ADMIN = "a0ce8463-c6a4-42c0-8407-8078d401c667";
const TIME_ADMIN = "7664e21c-65f2-4f7f-99b7-2015443b3025";
const USERS_ADMIN = "36220cf9-4414-4b12-acd0-21b07db00a37";
// Temporary
const ALLIANCE = "a6c4c1a6-0381-46f7-a4e0-7111b3692c29";

export default {
  ADMIN,
  BETA_FEATURE,
  BILLING_ADMIN,
  CALAMITY_ADMIN,
  CALLS_ADMIN,
  CLIENT_ADMIN,
  COURIER_ADMIN,
  FLIGHTS_ADMIN,
  HIDDEN,
  PHONES_ADMIN,
  QUEUE_ADMIN,
  TIME_ADMIN,
  USERS_ADMIN,
  ALLIANCE
};
